<template>
  <div>Analytics View</div>
</template>

<script>
export default {
  name: "AnalyticsView",
};
</script>
